import { defineAsyncComponent } from 'vue'

export default app => {
  app.component('PlatformResourcesPage', defineAsyncComponent(() => import('./ResourcesPage')))
  app.component('PlatformShowResourcePage', defineAsyncComponent(() => import('./ShowResourcePage')))
}
